<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <b-card :header="$t('general.isometric_management.material_requests.title')" header-tag="h3" class="bg-default-card">
                    <data-table
                        v-if="tableLoaded"
                        :exportable = "false" title=""
                        :rows="getData.rowData"
                        :columns="columnData"
                        :perPage="perPage"
                        :rowsCount="rowsCount"
                        :currentPage="currentPage"
                        :pageCount="pageCount"
                        @rowClickDelete="onDeleteRow"
                        @rowClickPDF="onPDF"
                        @rowClickView="onViewRow"
                        @changePage="changePage"
                        @searchEvent="searchEvent"
                        @orderByEvent="orderByEvent"
                        >
                    </data-table>

                    <b-btn class="btn btn-dark mt-3" @click="returnTo">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i> {{$t('general.buttons.return_to.return_to_isometric_management')}}
                    </b-btn>
                </b-card>
            </div>
        </div>

        <b-modal ref="requestModal" :cancel-title="$t('misc.cancel')" :title="requestTitle" size="lg" :ok-disabled="this.$store.state.ajax_in_progress">
            <data-table
                :search="false"
                :exportable="false"
                v-if="tableLoaded2"
                :rows="getData.rowData2"
                :columns="columnData2"
                :perPage="perPage2"
                :rowsCount="rowsCount2"
                :currentPage="currentPage2"
                :pageCount="pageCount2"
                @changePage="changePage2"
                @orderByEvent="orderByEvent2"
                >
            </data-table>
        </b-modal>

        <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>

        <confirm-dialog ref="pdfModal" :title="actionTitlePdf" @buttonClick="onDownloadPDF">
            <p class="m-0">{{ $t('messages.download_pdf') }}</p>
        </confirm-dialog>
    </div>
</template>

<script>
    import Vue from 'vue';
    import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
    import DataTable from '@/components/global/tables/datatables/DataTable.vue';
    import http from '@/libs/http';

    import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
    import miniToastr from 'mini-toastr';

    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);

    import { Validator } from 'vee-validate';

    import Multiselect from 'vue-multiselect';
    Vue.component(Multiselect);

    export default {
    name: 'isometric_material_request',
    components: {
        DataTable,
        ConfirmDialog,
        notificationIcons,
        VeeValidate,
        Multiselect
    },
    data() {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/'
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.isometric_management.title'),
                    active: true
                },
                {
                    text: this.$route.params.id2 + '',
                    active: true
                },
                {
                    text: Vue.i18n.translate('general.isometric_management.material_requests.title'),
                    active: true
                }
            ],
            tableName: 'drawing_request',
            tableNameTranslated: Vue.i18n.translate('general.construction.material_management.isometric_request.request'),
            actionTitle: '',
            requestTitle: '',
            row: null,
            tableLoaded: false,
            toggleLabels: false,
            perPage: 0,
            rowsCount: 0,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            isLoading: false,
            searchText: '',
            requests: {},
            getData: {
                rowData: [],
                rowData2: [],
            },
            tableLoaded2: false,
            row2: '',
            actionTitlePdf: '',
            perPage2: 0,
            rowsCount2: 0,
            pageCount2: 0,
            currentPage2: 1,
            sortType2: 'asc',
            sortBy2: 'id',
            model: {
                description: null,
                number: null,
                material: null,
                size: null,
                sizer: null,
                thk: null,
                thkr: null,
                dimension: null,
                total_qty: null,
                measureunit: null,
                unitweight: null,
                totalweight: null,
                note: null,
                prefab_material: false,
                erection_material: false,
            },
            columnData: [
                {
                    width: '90px',
                    label: Vue.i18n.translate('misc.actions'),
                    field: '',
                    showDeleteButton: true,
                    showPDF: true,
                    showViewButton: true,
                },
                {
                    label: Vue.i18n.translate('table.id'),
                    field: 'id',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.area'),
                    field: 'drawing.line.area',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.line_no'),
                    field: 'drawing.line.line_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.serial_no'),
                    field: 'drawing.line.serial_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.iso_no'),
                    field: 'drawing.iso_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.page_no'),
                    field: 'drawing.page',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.date'),
                    field: 'created_at',
                    numeric: false,
                    html: false,
                    datetime: true,
                },
                {
                    label: Vue.i18n.translate('table.status'),
                    field: 'status',
                    numeric: false,
                    html: false,
                }
            ],
            columnData2: [
                {
                    label: Vue.i18n.translate('table.requested'),
                    field: 'req_qty',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.status'),
                    field: 'status',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_number'),
                    field: 'number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_description'),
                    field: 'description',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_material'),
                    field: 'material',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_size'),
                    field: 'size',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_thk'),
                    field: 'thk',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_sizer'),
                    field: 'sizer',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_thkr'),
                    field: 'thkr',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_dimension'),
                    field: 'dimension',
                    numeric: false,
                    html: false,
                }
            ]
        }
    },
    mounted () {
        this.onLoadTable();
        this.buttonYes = Vue.i18n.translate('misc.yes');
        this.buttonNo = Vue.i18n.translate('misc.no');
        this.toggleLabels = {checked: this.buttonYes, unchecked: this.buttonNo};
    },
    methods: {
        onSelectSearch(search) {
            if (search == '') {
                this.getData.currentDisciplines = [];
                
                return false;
            }

            this.isLoading = true;
            this.search(search, this);
        },
        search: _.debounce((search, vm) => {
            let data = http.route('discipline?project_id='+vm.$route.params.id+'&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.getData.currentDisciplines = response.data;
                }
                vm.isLoading = false;
            });
        }, 500),
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput
            this.onLoadTable();
        },
        returnTo() {
            this.$router.go(-1);
        },
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            let data = http.route('drawing_request?drawing_id='+this.$route.params.id2+'&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get();
            data.then(response => {
                if (!response.isError) {
                    this.perPage = response.pagination.limit;
                    this.rowsCount = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount = response.pagination.totalPages;
                    var data = response.data;
                    data.forEach(field => {
                        if (field.discipline_id == null || field.discipline_id == '') {
                            field.discipline = { 'name': '' };
                        }
                        if (field.req_qty && typeof(this.requests[field.id]) == 'undefined') {
                            this.requests[field.id] = field.req_qty;
                        } else if (typeof(this.requests[field.id]) != 'undefined') {
                            field.req_qty = this.requests[field.id];
                        }
                        field.status = Vue.i18n.translate('table.'+field.status);
                    });
                    this.getData.rowData = data;
                    this.tableLoaded = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onDeleteRow (row, index) {
            this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                let data = http.route(this.tableName + '/' + this.row.id).delete();
                data.then(response => {
                    if(!response.isError) {
                        if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                            this.currentPage = this.currentPage - 1;
                        }

                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
            this.$refs.deleteModal.hide();
        },
        onPDF (row) {
            this.actionTitlePdf = Vue.i18n.translate('general.buttons.download_pdf');
            this.row = row;
            this.$refs.pdfModal.show();
        },
        onDownloadPDF (button) {
            if(button == 1) {
                let data = http.route('drawing_request/' + this.row.id).get(
                {
                    export_pdf_request: 1
                }, true);
                data.then(response => {
                    if (!response.isError) {
                        let data = http.route('get_content/'+response.data.type+'/'+response.data.id+'/'+response.data.name).downloadPdf({}, response.data.name).then(res => {
                            if (typeof res == 'undefined') {
                                miniToastr.success(Vue.i18n.translate('messages.pdf_generated'), Vue.i18n.translate('messages.success'));
                            } else {
                                Object.keys(res.errorMessage).forEach(key => {
                                    this.errorMsg(Vue.i18n.translate(res.errorMessage[key]));
                                });
                            }
                        });
                    } else {
                        miniToastr.error(Vue.i18n.translate('errors.error_generating_pdf'), Vue.i18n.translate('messages.error'));
                    }
                });
            }
            this.$refs.pdfModal.hide();
        },
        onViewRow (row, index) {
            this.requestTitle = Vue.i18n.translate('general.part.requested_materials');
            this.row = row;
            this.onLoadTable2();
            this.$refs.requestModal.show();
        },
        changePage2 (page) {
            this.currentPage2 = page;
            this.onLoadTable2();
        },
        orderByEvent2 (column, sort_type) {
            this.onLoadTable2();
        },
        onLoadTable2 () {
            let data = http.route('drawing_request/'+this.row.id+'?drawing_id='+this.$route.params.id2+'&get_parts=1&page=' + this.currentPage2 + '&sort_by=' + this.sortBy2 + '&sort_order=' + this.sortType2).get().then(response => {
                this.perPage2 = response.pagination.limit;
                this.rowsCount2 = response.pagination.totalEntries;
                this.currentPage2 = response.pagination.currentPage;
                this.pageCount2 = response.pagination.totalPages;
                var data = response.data;
                data.forEach(field => {
                    field.status = Vue.i18n.translate('table.'+field.status);
                });
                this.getData.rowData2 = data;
                this.tableLoaded2 = true;
            });
        },

    }
}
</script>

<style scoped>
    .multiselect-custom {
        width: 300px !important;
        height: 40px !important;
    }
    .multiselect__input:focus {
        width: 100% !important;
    }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/pages/project/isometric_management/isometric_material_request.vue